import { useNavigate } from "react-router-dom";

function About() {
  const navigate = useNavigate();
  return (
    <>

      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            About Us
          </h4>

        </div>
      </div>
      {/* Header End */}

      {/* Team Start */}
      <section className="container portfolio section-padding" id="portfolio" style={{ marginBottom: -60}}>
        <div className="row text-left">
          <div className="col-lg-12 col-sm-12 col-xs-12">
            <div className="section-title  wow zoomIn">
              <div className="indented">
                <section class="portfolio  section-padding">
                  <h3>Celersoft is the right size for your project needs!</h3>
                  <p>Headquarters in Houston, Texas, Celersoft is a leading IT consulting and services provider dedicated to empowering businesses with tailored technology solutions. With an extensive global reach, we offer "onshore, nearshore, and offshore" support services to U.S.-based clients across a variety of industries. Our team brings specialized expertise in<strong> Infrastructure Solutions, Cybersecurity, Business Analytics, Microservices, ERP Solutions, Managed Services, and IT Staffing.</strong> </p>
                  <h3>What Makes Celersoft Different? </h3>
                  <p><strong>Our people. </strong></p> <p>We believe that our team's dedication, skills, and values are our greatest assets. Their expertise enables us to deliver transformative results and exceptional quality to our clients. </p>
                  <h3>Commitment to excellence</h3>
                  <p>Celersoft operates with two primary objectives: <strong>enhancing efficiency and driving productivity</strong>. We achieve this through streamlined organizational practices, a global delivery infrastructure, and a commitment to delivering measurable outcomes that reduce costs and increase operational effectiveness.</p>
                  <p>Our focus on intensive recruitment, training, and retention allows us to maintain a reliable, skilled, and productive workforce ready to meet the evolving needs of our clients.</p>
                  <h3>The Celersoft Value Add in a Digital Age</h3>
                  <p>We are more than a service provider — we are a <strong>partner in your success</strong>.
                     Our specialized knowledge, industry experience, and commitment to quality empower businesses to thrive in a rapidly evolving digital landscape.</p>
                  <h3> Why Clients Choose Celersoft</h3>
                  <ul style={{padding:1% 1% 1% 1,fontWeight:400}}>
                    <li style={{ lineHeight:1.1 }}>Customer-centric delivery with <strong>on-time and on-budget</strong>execution</li>
                    <li style={{ lineHeight:1.1 }}><strong>On-demand consulting </strong>with flexible payment options</li>
                    <li style={{ lineHeight:1.1 }}>Flexible delivery models that reduce project lifecycle timelines and lower<strong> Total Cost of Ownership (TCO)</strong></li>
                    <li style={{ lineHeight:1.1 }}><strong>Expertise</strong> across diverse domains with industry-specific best practices
                       </li>
                    <li style={{ lineHeight:1.1 }}>Proven success in<strong> application performance monitoring (APM)</strong> deployments</li>
                    <li style={{ lineHeight:1.1 }}>Robust<strong> quality assurance </strong>processes to ensure defect-free delivery</li>
                  </ul>
                  {/* <h3>Where Expertise Meets Commitment</h3>
                  <p>Headquartered in Houston, Texas, Celersoft is a leading IT consulting and fortune 2000, Oil and Gas services provider dedicated to empowering businesses with tailored technology solutions. With an extensive global reach, we offer nearshore and offshore software development and support services to U.S.-based clients across a variety of industries. Our team brings specialized expertise in Artificial Intelligence (AI), Machine Learning (ML), Cloud Services, Application Development, Infrastructure Solutions, Business Analytics, Cybersecurity, and more.</p>
                  <p>What makes Celersoft different? Our people. We believe that our team’s dedication, skills, and values are our greatest asset in delivering transformative results for our clients.</p>
                  <h3>Our Mission</h3>
                  <p>At Celersoft, we are driven by a mission to deliver the highest standard of service with the integrity, flexibility, and personalized attention of a dedicated partner. As the premier workforce advisor in the industry, we know that performance matters. We are committed to understanding and fulfilling the unique needs of every client, no matter the size or scope of their projects.</p>
                  <h3>Our Story</h3>
                  <p>Founded in 2007, Celersoft was built on a simple yet powerful philosophy: to connect top talent with great companies in need of specialized expertise. Initially focused on staffing solutions for the Oil & Gas industry, Technology, Accounting, Legal, and Administrative sectors, we have grown into a comprehensive provider of IT and consulting services for organizations across diverse industries.</p>
                  <p>Our values are rooted in:</p> */}
                  {/* <ul>
                    <li>Delivering exceptional quality to our clients.</li>
                    <li>Treating each candidate with the utmost respect and care.</li>
                    <li>Only presenting the highest-quality candidates.</li>
                    <li>Acting in the best interest of both clients and candidates.</li>
                    <li>Prioritizing Relationships, Reliability, and Results—our core pillars of success.</li>
                  </ul> */}
                  {/* <h3> Our Approach: Efficiency and Productivity </h3>
                  <p>Celersoft operates with two primary objectives: enhancing efficiency and driving productivity. We achieve this through streamlined organizational practices, a worldwide infrastructure, and a commitment to delivering measurable outcomes that reduce costs and increase operational effectiveness for our clients. Our focus on intensive recruitment, training, and retention empowers us to provide a reliable, skilled, and productive workforce that meets the evolving needs of our partners.</p>
                  <h3>Let’s Transform Together</h3>
                  <p>At Celersoft, we are more than a service provider; we are a partner in your success. Our team’s specialized knowledge, experience, and dedication to quality empower businesses to thrive in a rapidly evolving digital landscape.</p>
                  <p><strong>Join us in building a more connected, efficient, and innovative future.</strong></p> */}
                  {/* </section>
                <section>
                  <h3>Value Proposition</h3>
                  <ul>
                    <li>
                      Customer satisfaction with on-time and on-budget delivery.
                    </li>
                    <li>Consulting on-demand with tailored payment options.</li>
                    <li>
                      Offshore delivery model to reduce project implementation
                      lifecycle and lower TCO.
                    </li>
                    <li>
                      Expertise in varied domains and industry-specific best
                      practices.
                    </li>
                    <li>
                      Successful application performance monitoring deployments.
                    </li>
                    <li>
                      Robust quality assurance processes to ensure defect-free
                      delivery.
                    </li>
                  </ul>
                </section> */}
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="col-md-12 d-flex justify-content-center" style={{ marginTop: "-140px" }}>
        <div className="actions">
          <button
            className="btn btn-lg btn-primary"
            id="getInTouchButton"
            
            onClick={() => navigate("/contact")} // Navigate to Contact Us page
          >
            Get in Touch
          </button>
        </div>
      </div>

       {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                className="border-bottom text-primary"
                href="https://htmlcodex.com"
              >
                HTML Codex
              </a>{" "}
              Distributed By{" "}
              <a
                className="border-bottom text-primary"
                href="https://themewagon.com"
              >
                ThemeWagon
              </a>


            </div> */}
          </div>
        </div>
      </div>
      {/* <a href="/About" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>

    </>
  );
};

export default About